import { showsFlowSignalsTab } from '@shared/flow/role-view';
import type { FlowRole } from '@shared/flow/role';
import { DEFAULT_SUBTAB, type Subtab } from '../../../../../../mini-apps/command-center/subtabs';

const NO_HIDDEN_TABS: readonly Subtab[] = [];
const SIGNALS_HIDDEN: readonly Subtab[] = ['signals'];

/**
 * Flow tabs hidden for a role. Signals renders only once the role has loaded,
 * so a GS rep never sees it flash in and out.
 */
export function hiddenSubtabsForTeam(team: FlowRole | null, isLoaded: boolean): readonly Subtab[] {
  return isLoaded && showsFlowSignalsTab(team) ? NO_HIDDEN_TABS : SIGNALS_HIDDEN;
}

/** The tab to open for a remembered one: the default when the role hides it. */
export function visibleSubtabForTeam(subtab: Subtab, team: FlowRole | null, isLoaded: boolean): Subtab {
  return hiddenSubtabsForTeam(team, isLoaded).includes(subtab) ? DEFAULT_SUBTAB : subtab;
}
